// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"style__modalBody__mHG+S","modalButtons":"style__modalButtons__G8mV8"};